<div class="tooglenav">

  <div class="linksec">
    <div class="mainLabel">
      Management <mat-icon>expand_more</mat-icon>
    </div>  
  
    <ng-container>
      <div class="sublist">
        <a  [routerLink]="'/organization'" routerLinkActive="active-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          All Organization
        </a>
      </div>
    </ng-container>
  </div>
  
  <div class="linksec">
    <div class="mainLabel">
      Admin <mat-icon>expand_more</mat-icon>
    </div>

    <ng-container>
      <div class="sublist">
        <a *ngIf="showUser" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin'">
          Users
        </a>
  
        <a *ngIf="showPermission" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin/permissions'">
          Permissions
        </a>
  
        <a *ngIf="showRole" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin/role'">
          Roles
        </a>
  
        <!-- <a *ngIf="showOrganization" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin/organization'">
          Organization
        </a> -->
  
        <a *ngIf="showModule" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin/module'">
          Module
        </a>
  
      </div>
    </ng-container>
  
  </div>
  
  <div class="linksec" *ngIf="showLoginDetails">    
    <div class="mainLabel">
      All Login Details <mat-icon>expand_more</mat-icon>
    </div>  
  
    <ng-container>
      <div class="sublist">
        <a routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin/logindetails'">
         Login Details
        </a>
      </div>
    </ng-container>
    </div>
  
  
  </div>